import { ADD_AWARD, ADD_AWARD_FAILED, ADD_AWARD_SUCCESS, AWARD, AWARD_FAILED, AWARD_SUCCESS, UPDATE_AWARD, UPDATE_AWARD_FAILED, UPDATE_AWARD_SUCCESS, UPDATE_DEPARTMENT_FAILED } from "./actionTypes"

let initialState = {
    award: [],
    addAward: "",
    updateAward: "",
    loading: false,
    success: false,
    error: ''
}

export const awardReducer = (state = initialState, action) => {
    switch (action.type) {

        case AWARD: return {
            ...state,
            loading: true,
            success: false,
            error: ''
        }
        case AWARD_SUCCESS: return {
            ...state,
            award: action.payload,
            loading: false,
            success: true
        }
        case AWARD_FAILED: return {
            ...state,
            loading: false,
            success: false,
            error: action.payload
        }
        case ADD_AWARD: return {
            ...state,
            loading: true,
            success: false,
            error: ''
        }
        case ADD_AWARD_SUCCESS: return {
            ...state,
            addAward: action.payload,
            award: [...state.award, action.payload],
            loading: false,
            success: true,
            error: ''
        }
        case ADD_AWARD_FAILED: return {
            ...state,
            addAward: [],
            loading: false,
            success: false,
            error: action.payload
        }
        case UPDATE_AWARD: return {
            ...state,
            loading: false,
            success: false,
            error: ''
        }
        case UPDATE_AWARD_SUCCESS: return {
            ...state,
            updateAward: action.payload,
            award: state.award.map((item) => item.id === action.payload.id ? action.payload : item),
            loading: false,
            success: true,
            error: ''
        }
        case UPDATE_AWARD_FAILED: return {
            ...state,
            updateAward: [],
            loading: false,
            success: false,
            error: action.payload
        }

        default: return state
    }
}